<script lang="ts" context="module">
  import { CONSTANTS } from '../../../../common/config/constants';
  import { getStr, globalCurrencyTag, JoodType } from '../../../../common/util';
</script>

<script lang="ts">
  export const vasPrice = 0;
  export let joodType: JoodType;
  export let oldVasPrice = null;
  export let vasLabel;
  export let vasName = '';
  export let isNoPlan = false;

  const { BASIC, VIP, SMART } = CONSTANTS;

  let vasTitle = 'extra.pdp.prime.gold.display.text';

  $: if (joodType === 'BASIC') {
    vasTitle = 'extra.pdp.prime.blue.display.text';
  }

  $: prices = pickPrices(oldVasPrice);
  $: vasTitle = pickJoodVasTitle(joodType);
  $: joodLabelVisible = prices.discount > 0;

  function pickPrices(oldVasPrice) {
    const discount = 0;
    const current = oldVasPrice;
    const old = oldVasPrice;
    return {
      old,
      current,
      discount,
    };
  }

  function pickJoodVasTitle(joodType: JoodType) {
    switch (joodType) {
      case BASIC:
        return 'extra.pdp.prime.blue.display.text';
      case VIP:
        return 'extra.pdp.prime.gold.display.text';
      case SMART:
        return 'extra.pdp.prime.smart.display.text';
    }

    return 'extra.pdp.prime.noprime.display.text';
  }
</script>

<section class="c_joodcart c_joodvas-subs-price">
  <div class="c_joodvas-subs-price-wrapper">
    <div class="c_vas-type">
      <span class="vas-label">
        {vasLabel}
      </span>
      {#if vasName?.length > 0 && !isNoPlan}
        <span class="vas-type-name">
          <strong>{vasName}</strong>
        </span>
      {/if}
    </div>
    <section class="c_joodvas-subs-details">
      {#if +prices.current > 0}
        {#if joodLabelVisible}
          <div class="c_joodvas-subs-label">{getStr(vasTitle)}</div>
        {/if}
        <section class="c_joodvas-price-details">
          {@html globalCurrencyTag}
          <span class="fw-bold">
            {prices.current}
          </span>
        </section>
      {/if}
    </section>
  </div>
</section>
